import { DefaultService } from '@/services/DefaultService';

export default class FormularioService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    findAll (filtro, params) {
        return this._http.post(encodeURI(`${this._env}/geoanalysis/ocorrencias.json?param=${params}`), filtro, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    getChartByTitulo(titulo, filters) {
        return this._http.post(`${this._env}/geoanalysis/ocorrencias/chart/${titulo}`, filters, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getAllCharts (filtro) {
        return this._http.post(encodeURI(`${this._env}/geoanalysis/ocorrencias/allcharts.json`), filtro, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    
}